import styles from "../../pages/contact-us/contact-us.module.css";
const pin = "../../assets/images/contact/pin.png";
const call = "../../assets/images/contact/call.png";
const mail = "../../assets/images/contact/mail.png";
const redrightarrow = "../../assets/images/contact/redrightarrow.png";
import dynamic from 'next/dynamic';
const Image = dynamic(() => import("next/image"));
const Link = dynamic(() => import("next/link"));

const BranchDelhiAddress = () => {   

   const contactcontent = [

     {
      heading: "Delhi",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,   
      address:
        "Shop Number 78 First Floor,<br /> Old Rajinder Nagar Market,<br /> Karol Bagh, New Delhi - 110060 <br/> <br/> Landmark: Popular Juice Shop.",
      phones: [
        { label: "", number: "88991 80180" }
      ],
      email: "delhi@shankarias.in",
      url: "https://maps.app.goo.gl/V3EtvvYvqNjfK1XN9",
      url1: "https://maps.app.goo.gl/V3EtvvYvqNjfK1XN9"
    },
    
    
    
    {
      heading: "Shankar IAS Academy - Head Office",
      Image: pin,
      Image1: call,
      Image2: mail,
      Image3: redrightarrow,  
      address:
        "Door No 18, Old plot No 109,<br/>AL Block, 4th Avenue,<br/>Anna Nagar, Chennai - 600040",
      phones: [
        { label: "", number: "9003190030" }
      ],
      email: "enquiry@shankarias.in",
      url: "https://www.google.com/maps/place/Shankar+IAS+Academy+Chennai+-+IAS+Academy+in+Chennai+%7C+Best+UPSC+Coaching+Centre/@13.0820596,80.2030261,14.75z/data=!4m6!3m5!1s0x3a52654d8fc25ff7:0x9b278e8700a30d6!8m2!3d13.0823643!4d80.2047976!16s%2Fg%2F11fjr76z1j?hl=en",
      url1: "https://www.google.com/maps/place/Shankar+IAS+Academy+Chennai+-+IAS+Academy+in+Chennai+%7C+Best+UPSC+Coaching+Centre/@13.0820596,80.2030261,14.75z/data=!4m6!3m5!1s0x3a52654d8fc25ff7:0x9b278e8700a30d6!8m2!3d13.0823643!4d80.2047976!16s%2Fg%2F11fjr76z1j?hl=en"
    },

  
  ]


  return (
    <>

   <section id="tnpsccentres">
        <div className="container-fluid" style={{ background: '#E2F6FF 0% 0% no-repeat padding-box' }}>
          <div className="row">
            <div className="col py-5 px-0">

              <div className="container">
                <div className="row">
                  <div className="col">
                    <h2 className={`${styles.sectiontitle}`}>Our Branches</h2>
                  </div>
                </div>
              </div>

              <div className="container pt-3">
                <div className="row">

                  <div className="col">
                    <div className="row">

                      {contactcontent.map((item, index) => (
                        <div className="col-md-6 col-lg-4 col-12 mb-3">
                            <div className={`${styles.contactbox} h-100`}>
                              <div className={`${styles.contactboxheight} px-4 pt-4 pt-md-5`}>

                                {/* Heading */}
                                <div className={`${styles.acheivername2} mb-3`}>
                                  {item.heading}
                                </div>

                                {/* Address */}
                                <div className="row">
                                  <div className="col-1 pe-0">
                                    <Image src={item.Image} width={14} height={14} alt="location" />
                                  </div>
                                  <div className="col-11">
                                    {item.address && (
                                      <div
                                        className={styles.acheiverrank}
                                        dangerouslySetInnerHTML={{ __html: item.address }}
                                      />
                                    )}
                                    {item.address1 && (
                                      <div className={styles.acheiverrank}>
                                        {item.address1}
                                      </div>
                                    )}
                                    {item.address2 && (
                                      <div className={styles.contactsubcontent}>
                                        {item.address2}
                                      </div>
                                    )}
                                  </div>
                                </div>

                                {/* Phone Numbers */}
                                {item.phones?.length > 0 && (
                                  <div className="row mt-2">
                                    <div className="col-1 pe-0 d-flex align-items-start">
                                      <Image
                                        src={item.Image1}
                                        width={16}
                                        height={16}
                                        alt="phone"
                                      />
                                    </div>

                                    <div className="col-11">
                                      {item.phones?.map((phone, index) => (
                                        <div key={index} className="mb-1">
                                          <a
                                            href={`tel:${phone.number.replace(/[^0-9]/g, "")}`}
                                            className={styles.mobilemaillinks}
                                          >
                                            {phone.number}
                                          </a>
                                        </div>
                                      ))}
                                    </div>
                                  </div>

                                )}

                                {/* Email */}
                                {item.email && (
                                  <div className="row mt-2">
                                    <div className="col-1 pe-0">
                                      <Image src={item.Image2} width={14} height={14} alt="email" />
                                    </div>
                                    <div className="col-11">
                                      <p className={styles.acheiverrank}>
                                        <a
                                          href={`mailto:${item.email}`}
                                          className={styles.mobilemaillinks}
                                        >
                                          {item.email}
                                        </a>
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </div>

                              {/* ===== Direction + Arrow Section ===== */}
                              {(item.url || item.url1) && (
                                <>
                                  <hr className="mb-0" />
                                  <div className="px-4 pb-1 py-md-2">
                                    <div className="row align-items-center">
                                      
                                      {/* Direction Text */}
                                      <div className="col-9 col-xl-10">
                                        {item.url && (
                                          <Link
                                            href={item.url}
                                            target="_blank"
                                            className={styles.redunderline}
                                          >
                                            {item.direction || "Get Directions"}
                                          </Link>
                                        )}
                                      </div>

                                      {/* Arrow Image */}
                                      <div className="col-3 col-xl-2 text-end">
                                        {item.url1 && item.Image3 && (
                                          <Link href={item.url1} target="_blank">
                                            <Image
                                              src={item.Image3}
                                              width={30}
                                              height={30}
                                              className={`${styles.img} img-fluid`}
                                              alt="arrow"
                                            />
                                          </Link>
                                        )}
                                      </div>

                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                        </div>
                      ))}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default BranchDelhiAddress